'use strict';

const assertUnreachable = (x) => `Unreachable code executed with ${x}`;

exports.assertUnreachable = assertUnreachable;
//# sourceMappingURL=assertUnreachable.js.map
